module.exports = __webpack_public_path__ + "img/previous.7f9e1ac5.png";